import { AppLayout } from '../components/app-layout/AppLayout'
import { TopBar } from '../components/top-bar/TopBar'

type LoadingScreenProps = {
  logo: React.ReactNode
  loadingMessage: string
  useMobileBar?: boolean
}

export const LoadingScreen = ({
  logo,
  loadingMessage,
  useMobileBar
}: LoadingScreenProps) => (
  <AppLayout
    topBar={<TopBar logo={logo} />}
    useMobileBar={useMobileBar}
    isLoading={true}
    loadingMessage={loadingMessage}
  />
)
